import React from "react";
import { fmtDate } from "../../lib/customers";

const ROWS = [
  ["Customer ID", "customer_code"], ["Full Name", "name"], ["Father's Name", "father_name"], ["Mother's Name", "mother_name"],
  ["Date of Birth", "dob", "date"], ["Gender", "gender"], ["Mobile", "mobile"], ["Alternate Mobile", "alt_mobile"], ["Email", "email"],
  ["Instagram", "insta_id"], ["Full Address", "address"], ["Village", "village"], ["Post Office", "post_office"], ["Panchayat", "panchayat"],
  ["Block", "block"], ["District", "district"], ["State", "state"], ["PIN Code", "pin"], ["Qualification", "qualification"],
  ["Customer Type", "customer_type"], ["Branch", "branch_name"], ["Enquiry", "enquiry_subject"], ["Dubara kab aayega", "revisit_at", "dt"],
  ["Call karna hai", "call_back", "bool"], ["Follow-up", "add_followup", "bool"], ["Consent", "consent", "bool"],
  ["Data retention till", "retention_until", "date"], ["Created By", "created_by"], ["Created", "created_at", "dt"], ["Last Updated", "updated_at", "dt"],
];

const val = (c, k, t) => {
  const v = c[k];
  if (t === "bool") return v ? "Haan" : "Nahi";
  if (t === "date") return v ? fmtDate(v) : "—";
  if (t === "dt") return v ? fmtDate(v, true) : "—";
  return v || "—";
};

export const PersonalTab = ({ c }) => (
  <div className="rounded-xl border border-slate-200 bg-white p-5 mt-3" data-testid="personal-tab">
    <dl className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-3 text-sm">
      {ROWS.map(([l, k, t]) => (
        <div key={k} className={k === "address" ? "sm:col-span-2 lg:col-span-3" : ""}>
          <dt className="text-[11px] uppercase tracking-wider text-slate-500">{l}</dt>
          <dd className="text-slate-900 whitespace-pre-wrap" data-testid={`personal-${k}`}>{val(c, k, t)}</dd>
        </div>
      ))}
    </dl>
  </div>
);
